// src/pages/OurHeritage.js
import React, { useEffect } from 'react';
import SeoHead from '../seo/SeoHead';
import OurHeritageHero from '../main/OurHeritageHero';
import HeritageBody from '../main/HeritageBody';

export default function OurHeritage() {
  // scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SeoHead
        title="Our Heritage – Marrakech Reserve"
        description="Explore Marrakech Reserve's centuries‑old olive groves in the heart of Morocco. From traditional hand‑harvest to modern cold‑pressing, discover our heritage of crafting world‑class extra virgin olive oil."
        url="https://marrakech-reserve.com/our-heritage"
        keywords={
          "Morrocan olive oil, buy moroccan olive oil, buy olive oil from morocco, buy olive oil, olive oil, olive oil heritage, Marrakech olive oil, traditional olive groves, Moroccan olive farming, " +
          "hand-harvested olives, cold-pressed olive oil, artisanal olive oil making, family-owned olive mill, " +
          "heritage olive oil, sustainable olive cultivation, gourmet olive oil, olive oil history, " +
          "organic olive groves, premium extra virgin olive oil, Marrakech Reserve heritage"
        }
      />
      <OurHeritageHero />
      <HeritageBody />
    </>
  );
}
